<script lang="ts">
  import { ship } from "../net/ship.svelte.js";
  import { session } from "../net/session.svelte.js";
  import { audio } from "../audio/bus.js";
  import { BUILD_LABEL } from "../lib/build.js";
  const show = import.meta.env.DEV || new URLSearchParams(location.search).has("debug");
</script>

{#if show}
  <p class="dev dim">
    {BUILD_LABEL} · tick {ship.snap?.tick ?? "-"} · seed {ship.snap?.seed ?? "-"} · session {session.sessionId.slice(-4)} · user …{session.userId.slice(-4)} · last hook {ship.lastHook || "-"} · audio {audio.ready ? "on" : "locked"}
  </p>
{/if}

<style>
  .dev { font-size: 0.8em; margin: 0.5rem 0 0; }
</style>
